module.exports = __webpack_public_path__ + "img/Hand_Outline.827cd0f.svg";